export const renderHighlightedTitle = (titleText: string) => {
  if (!titleText) return null;

  const parts = titleText.split(/\*\*(.*?)\*\*/);

  return parts.map((part, index) =>
    index % 2 === 1 ? (
      <span key={index} style={{ color: '#00CE00' }}>
        {part}
      </span>
    ) : (
      part
    )
  );
};
